import { defineAdderChecks } from '@svelte-add/core';
import { options } from './options.js';

export const checks = defineAdderChecks({
	options,
});
